var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"justify-self-center":"","align-self-center":""}},[_vm._v(" "+_vm._s(_vm.$t('Keine Daten'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }